import {fetchWithState, getFetchedJSON} from '~/misc/fetch';

export const asyncMemberSwitch = (getState) =>
  fetchWithState(getState, {
    method: 'GET',
    url: '/tl/window/conf?key=times_switch',
  }).then(getFetchedJSON);



// WEBPACK FOOTER //
// ./src/modules/premiumSwitch/api.js